module.exports = __webpack_public_path__ + "static/img/pure-huevo.a83e161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/pure-huevo.png
// module id = 243
// module chunks = 1